import './hero.scss';

export default () => {
	document.querySelectorAll('.js-scroll').forEach(function (element) {
		element.addEventListener('click', function (e) {
			e.preventDefault();
			let target = this.closest('.hero').nextElementSibling;
			if (target) {
				let scrollTo = target.offsetTop - 80;
				window.scrollTo({
					top: scrollTo,
					behavior: 'smooth'
				});
			}
		});
	});


};
